import $console from '@zuto/utilities/src/$console'
import { fireReactGAEvent } from '../components/Questions/utils'
import LookupRepository, { EmailValidationResponse } from '../repository/lookup-repository'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'

const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

interface LookupServiceResult {
  validateEmail: (email: string, source?: string) => Promise<EmailValidationResponse>
}

const LookupService = (config: Record<string, string>): LookupServiceResult => {
  const lookupRepository = LookupRepository(config)

  const validateEmail = (email: string, source?: string) => new Promise<EmailValidationResponse>((resolve, reject) => {
    lookupRepository
    .validateEmail(email, source)
    .then((data) => {
      
      if (data.isValid) {
        logEvent({
          data: data.message, 
          message: `Email Address Validated and is VALID`, 
          source
        })
        resolve(data)
      }

      if (!data.isValid) {
        const hasDYM = data.didYouMean
        logEvent({
          data: data.message, 
          message: `Email Address Validated and is INVALID - user ${hasDYM ? 'shown' : 'not shown'} DYM`, 
          source
        })
        reject({
          message: data.message as string || ''
        })
      }
    }).catch((error) => {
      logEvent({
        data: error, 
        message: 'Email Address was not validated as LookupService Failed', 
        source
      })
      // Don't block users when the lookup-service fails (service was down, network error, etc)
      resolve(error)
    })
  })

  return {
    validateEmail
  }
}


const logEvent = ({data, message, source}: {data: any , message: string, source?: string}) => {
  $console.error(JSON.stringify(data))
  try {
    zutoAnalyticsHelper.sendCustomEventAsync({
      eventType: 'Validation Error',
      eventCategory: 'Application Form',
      eventAction: message,
      eventSource: source,
      eventData: JSON.stringify(data)
    })
  } catch (e) {
    $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
  }
  fireReactGAEvent({
    category: 'Application Form',
    action: 'Validation',
    label: message,
    nonInteraction: true
  })
}

export default LookupService